/* Accueil premium (sections clown-hp-*) : apparitions au scroll,
   décompte des chiffres clés, parallaxe douce du hero sur desktop.
   Sans JS ou avec « réduire les animations », tout reste visible et statique :
   l'état masqué n'existe que sous .hp-anim, ajoutée ici. Script chargé par chaque
   section : la garde évite une double initialisation. */
(function () {
  if (window.__clownHp) return;
  window.__clownHp = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* « +1 000 », « 4,7 ★ », « 100 % » : on anime la partie numérique, on garde le reste tel quel. */
  function countUp(el) {
    var raw = el.textContent;
    var match = raw.match(/(\d[\d\s ]*)(,(\d+))?/);
    if (!match) return;
    var intPart = match[1].replace(/[\s ]/g, '');
    var decimals = match[3] ? match[3].length : 0;
    var target = parseFloat(intPart + (decimals ? '.' + match[3] : ''));
    if (!isFinite(target)) return;
    var before = raw.slice(0, match.index);
    var after = raw.slice(match.index + match[0].length);
    var start = null;
    var duration = 1400;
    function format(n) {
      var fixed = n.toFixed(decimals).split('.');
      var grouped = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return grouped + (decimals ? ',' + fixed[1] : '');
    }
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = before + format(target * eased) + after;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = raw;
    }
    requestAnimationFrame(frame);
  }

  ready(function () {
    var sections = document.querySelectorAll('.hp');
    if (!sections.length) return;
    sections.forEach(function (s) {
      // The hero image, title and purchase controls are visible immediately.
      if (!s.hasAttribute('data-hp-hero')) s.classList.add('hp-anim');
    });

    /* Keep the hero available to the optional desktop parallax below. */
    var hero = document.querySelector('[data-hp-hero]');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        /* Dans un carrousel mobile, les cartes hors écran apparaissent avec la première :
           sinon elles resteraient vides pendant le glissement. */
        var rail = el.closest('.hp-rail');
        var group = rail ? rail.querySelectorAll('[data-hp-reveal]') : [el];
        Array.prototype.forEach.call(group, function (item) {
          item.classList.add('is-in');
          item.querySelectorAll('[data-hp-count]').forEach(countUp);
          io.unobserve(item);
        });
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    document.querySelectorAll('.hp [data-hp-reveal]').forEach(function (el) { io.observe(el); });

    /* Parallaxe douce de la photo du hero (desktop uniquement). */
    if (hero && window.matchMedia('(min-width: 990px)').matches) {
      var img = hero.querySelector('.hp-hero__img');
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking || !img) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = Math.min(window.scrollY, hero.offsetHeight);
          img.style.setProperty('--hp-parallax', (y * 0.18).toFixed(1) + 'px');
          ticking = false;
        });
      }, { passive: true });
    }
  });
})();
